{
  "empty-state": {
    "precondition-failed-message": "Наразі у даній групі менше користувачів,  ніж статистично безпечно відображати їх дані та результати"
  }
}
